// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__ty8ww","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2_Vwm"};